export enum IdentityVerificationResult {
    Unverified = 1,
    Pass = 2,
    Fail = 3
}

export enum IdentityVerificationRejectReason {
    AppRemovedNoPlanToUse = 'AppRemovedNoPlanToUse',
    PhoneLostChanged = 'PhoneLostChanged',
    PhoneConflict = 'PhoneConflict',
    NoAppNoPlanToUse = 'NoAppNoPlanToUse',
    NoAppWantInstall = 'NoAppWantInstall',
    Other = 'Other'
}
